export const CURRENT_TERMS_VERSION = '2026-09-20' as const;

export const RELEASE_CAPABILITIES = {
  peerMessagingAvailable: false,
} as const;
